import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getMobileOperatingSystem } from '../../utils/os';
import { Link } from 'react-router';
import { useSessionData } from '../../hooks/useSessionData';
import { Trans, useTranslation } from 'react-i18next';
import Header from '../../components/Header';

export function Summary() {
  const { t } = useTranslation();

  const { sessionData } = useSessionData();
  const firstName = sessionData().consumer?.firstName || '';
  const skippedLink = sessionData().skippedLink === 'true';

  const getStore = () => {
    if (getMobileOperatingSystem() === 'iOS') {
      return (
        <Trans t={t} i18nKey="pages.summary.almost_there">
          You&lsquo;re almost there! The next step is to download the Bridgeover app in the
          <a className="bo-link" href="https://apps.apple.com/us/app/bridgeover/id6449384243">
            {{ store: t('pages.summary.apple_store') }}
          </a>
          , and sign in using the email address and password you created during registration.
        </Trans>
      );
    }

    if (getMobileOperatingSystem() === 'Android') {
      return (
        <Trans t={t} i18nKey="pages.summary.almost_there">
          You&lsquo;re almost there! The next step is to download the Bridgeover app in the
          <a
            className="bo-link"
            href="https://play.google.com/store/apps/details?id=io.bridgeover.mobile"
          >
            {{ store: t('pages.summary.google_play') }}
          </a>
          , and sign in using the email address and password you created during registration.
        </Trans>
      );
    }

    return (
      <Trans t={t} i18nKey="pages.summary.almost_there">
        You&lsquo;re almost there! The next step is to download the Bridgeover app in the
        {{ store: t('pages.summary.not_mobile') }}, and sign in using the email address and password
        you created during registration.
      </Trans>
    );
  };

  return (
    <Container className="bo-mobile">
      <Header />
      <div className="bo-rounded-container mt-5">
        <Row className="mt-4 mx-3">
          <Col className="text-start">
            <p className="bo-text bo-larger-x2">
              {t('pages.summary.thank_you', { firstName: firstName ? ` ${firstName}` : '' })}
            </p>
          </Col>
        </Row>
        <Row className="mt-2 mb-0 mx-3">
          <Col className="text-start">
            <p className="bo-text">{getStore()}</p>
          </Col>
        </Row>
        <Row className="mt-2 mb-0 mx-3">
          <Col className="text-start">
            <p className="bo-text">
              {skippedLink
                ? t('pages.summary.not_required_to_connect')
                : t('pages.summary.account_active')}
            </p>
          </Col>
        </Row>
        {skippedLink && (
          <Row className="mt-2 mb-0 mx-3">
            <Col className="text-start">
              <p className="bo-text">{t('pages.summary.to_connect_bank')}</p>
            </Col>
          </Row>
        )}
        <Row className="mt-2 mb-0 mx-3">
          <Col className="text-start">
            <p className="bo-text-bold mb-1">{t('pages.summary.bridgepoints_title')}</p>
            <p className="bo-text">{t('pages.summary.bridgepoints_description')}</p>
          </Col>
        </Row>
        <Row className="mt-2 mb-0 mx-3">
          <Col className="text-start">
            <p className="bo-text-bold mb-1">{t('pages.summary.rewards_title')}</p>
            <p className="bo-text">{t('pages.summary.rewards_description')}</p>
          </Col>
        </Row>
        <Row className="mt-2 mb-4 mx-3">
          <Col className="text-start">
            <p className="bo-text-bold mb-1">{t('pages.summary.need_help_title')}</p>
            <p className="bo-text">
              <Trans t={t} i18nKey="pages.summary.need_help_description">
                To contact Bridgeover support, please click
                <Link className="bo-link" to="/signup/support">
                  here
                </Link>
                .
              </Trans>
            </p>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Summary;
